const inicialState = {
  dataInicio: '',
  dataFim: '',
  filtroValue: '',
  lista: [],
  page: 1,
  imprimir: false,
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/materiais/store/materiais.state.js